import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from './api';

const ThemeContext = createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(null);
  const [loading, setLoading] = useState(true);

  const applyTheme = (themeData) => {
    const root = document.documentElement;
    if (themeData.background) {
      root.style.setProperty('--background', themeData.background);
    }
    if (themeData.background_secondary) {
      root.style.setProperty('--background-secondary', themeData.background_secondary);
    }
    if (themeData.text) {
      root.style.setProperty('--text', themeData.text);
    }
    if (themeData.text_secondary) {
      root.style.setProperty('--text-secondary', themeData.text_secondary);
    }
    if (themeData.accent) {
      root.style.setProperty('--accent', themeData.accent);
    }
    if (themeData.accent_hover) {
      root.style.setProperty('--accent-hover', themeData.accent_hover);
    }
  };

  const updateTheme = (newTheme) => {
    setTheme(newTheme);
    applyTheme(newTheme);
  };

  const fetchTheme = useCallback(async () => {
    try {
      const response = await api.get('/api/settings/theme');
      setTheme(response.data);
      applyTheme(response.data);
    } catch (err) {
      console.error('Failed to fetch theme:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTheme();
  }, [fetchTheme]);

  return (
    <ThemeContext.Provider value={{ theme, loading, updateTheme, refetchTheme: fetchTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export default ThemeProvider;
